import { Badge } from "@/components/ui/badge";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { PAT } from "@/constants/testIds";
import {
  encounterClassLabel,
  encounterDate,
  encounterLocation,
  encounterNumber,
  encounterProvider,
  encounterReasonCodes,
  encounterStatusLabel,
  encounterTypeLabel,
  encounterVisitTypeLabel,
  formatDate,
} from "@/lib/patientChart";

const STATUS_STYLE = {
  planned: "bg-[#E5F0FF] text-[#1E79E8]",
  arrived: "bg-indigo-100 text-indigo-800",
  triaged: "bg-violet-100 text-violet-800",
  "in-progress": "bg-amber-100 text-amber-800",
  onleave: "bg-orange-100 text-orange-800",
  finished: "bg-emerald-100 text-emerald-800",
  cancelled: "bg-slate-200 text-slate-600",
};

function StatusBadge({ status }) {
  return (
    <Badge className={`${STATUS_STYLE[status] || "bg-slate-200 text-slate-600"} hover:opacity-100`}>
      {encounterStatusLabel(status)}
    </Badge>
  );
}

export default function EncounterTable({ encounters, onSelect, compact }) {
  const rows = compact ? encounters.slice(0, 5) : encounters;
  if (!encounters.length) {
    return <p className="py-6 text-center text-sm text-slate-500">No encounters available.</p>;
  }
  return (
    <div className="-mx-1 overflow-x-auto">
      <Table>
        <TableHeader>
          <TableRow className="hover:bg-transparent">
            <TableHead>Date</TableHead>
            {!compact && <TableHead>Encounter #</TableHead>}
            <TableHead>{compact ? "Type" : "Visit Type"}</TableHead>
            {!compact && <TableHead>Class</TableHead>}
            {!compact && <TableHead>Status</TableHead>}
            <TableHead>Provider</TableHead>
            {!compact && <TableHead>Location</TableHead>}
            {!compact && <TableHead>Diagnosis</TableHead>}
          </TableRow>
        </TableHeader>
        <TableBody>
          {rows.map((enc) => (
            <TableRow
              key={enc.id}
              data-testid={`${PAT.chartEncounterRow}-${enc.id}`}
              className={onSelect ? "cursor-pointer" : undefined}
              onClick={() => onSelect?.(enc)}
            >
              <TableCell className="whitespace-nowrap text-slate-700">
                {formatDate(encounterDate(enc))}
              </TableCell>
              {!compact && (
                <TableCell>
                  <span className="font-fhir text-sm text-[#1E79E8]">{encounterNumber(enc)}</span>
                </TableCell>
              )}
              <TableCell className="text-slate-700">
                {compact ? encounterTypeLabel(enc) : encounterVisitTypeLabel(enc)}
              </TableCell>
              {!compact && (
                <TableCell className="text-slate-700">{encounterClassLabel(enc)}</TableCell>
              )}
              {!compact && (
                <TableCell>
                  <StatusBadge status={enc.status} />
                </TableCell>
              )}
              <TableCell className="text-slate-700">{encounterProvider(enc)}</TableCell>
              {!compact && (
                <TableCell className="text-slate-700">{encounterLocation(enc)}</TableCell>
              )}
              {!compact && (
                <TableCell className="font-fhir text-sm text-slate-800">
                  {encounterReasonCodes(enc)}
                </TableCell>
              )}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
